<template>
  <div id="Stops">

     <b-container fluid>
        <b-row class="mb-1 text-center">
                    <b-col >  
                            <h1 class="labelBold">{{ this.$t(`bookingTransport.Platform.title`) }} </h1>
                    </b-col>
        </b-row>
    </b-container>
    <br/>

<b-container class="bv-example-row">
  <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
    <b-col>  
            <label class="labelBold">{{ $t("bookingTransport.Platform.name") }}</label>
            <input type="text" v-model="Anden" />
   </b-col>
    <b-col>  
        <button class="btn-confirm" @click="showModal">{{ $t("bookingTransport.Platform.add") }}</button>
    </b-col>
    <b-col>   
                <div class="container-input">
                <input type="file" name="file-2" id="file-2" class="inputfile inputfile-2" @change="loadCSV($event)" accept=".csv" data-multiple-caption="{count} archivos seleccionados" multiple />
                <label for="file-2">
                <i style='font-size:24px' class='fas'>&#xf6dd;</i>
                <span class="iborrainputfile" id="filecsv"> {{ $t("bookingTransport.selectFile") }}</span>
                </label>
                 <div >
                <i style='font-size:24px; float:left;' class='fas btn-outline-secondary' @click="showInf()">&#xf05a;</i>
                </div>
                <div v-if="file">
                <i style='font-size:24px; float:right;' class='fas btn-outline-secondary' @click="removeFile()">&#xf1f8;</i>
                </div>
                </div>
    </b-col>
    <b-col v-if="fileOk">
        <button class="btn-confirm" @click="Upload()">{{ $t("bookingTransport.Platform.upload") }}</button>
    </b-col>
  </b-row>
</b-container>
                <div class="row">
                          <div class="col-md-12">
                             <!--
                            <v-client-table v-if="tableData" :data="tableData" :columns="table_optionsCarga.columns" :options="table_optionsCarga.options">
                                 <template v-slot:action="props">
                                    <center><i style='font-size:24px' class='fas btn-outline-secondary' @click="Modify(props.row.name)">&#xf044;</i></center> 
                                    <b-button v-b-popover="'Popover inside a modal!'" title="Popover">Button</b-button> 
                                    </template> 
                            </v-client-table>-->   

                              <v-server-table :columns="table_options.columns" :options="table_options.options" ref="routesTable">
                                <template #driver_status="props">{{ translateStatus(props.row.driver_status) }}</template> 
                                
                                 <template v-slot:actions="props">
                                    <center><i style='font-size:24px' class='fas btn-outline-secondary' @click="Modify(props.row.route_name)">&#xf044;</i></center> 
                                    <!-- <b-button v-b-popover="'Popover inside a modal!'" title="Popover">Button</b-button> -->
                                    </template> 

                                  <!-- <div slot="filter__driver_status">
                                    <select class="form-control" name="driver_status" id ="driver_status" v-model="selected"  @change="filterStatus(selected)">
                                    <option v-for="option in options"
                                    v-bind:key="option.id"
                                    v-bind:value="option.id">
                                    {{option.name }}
                                    </option>
                                  </select>
                                  </div> -->
                            </v-server-table>
                      </div>   
                </div>

    <b-modal size="lg" centered ref="my-info"  scrollable :title="$t('users.search.infoCsv')" tabindex="-1" >
    <div v-if="appLang =='es'">
        <p>
              Archivo en formato .csv
              <br/>
              Nombre de columnas: Id_Ruta,	Descripción_Ruta  
               <br/>
            </p>
            </div>
                <div v-if="appLang =='en'">
              File in .csv format
              <br/>
              Column name: Id_Route, Description_Route
               <br/>
                </div>

        <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>    
             <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="DowloadLayout()"
          >
            {{ $t("bookingTransport.download") }}
          </b-button>
        </div>
      </template>
    </b-modal>

      <b-modal size="lg" centered ref="my-error" hide-footer scrollable :title="$t('bookingTransport.errorUpload')" tabindex="-1" >
           <div>
             <textarea v-model="error" class="form-control" rows="15">
             </textarea>
            </div>
       
        <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>    
            <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="DowloadLayout()">
            {{ $t("bookingTransport.download") }}
          </b-button>
        </div>
      </template>
    </b-modal>

        <b-modal size="lg" centered ref="my-edit" no-close-on-backdrop scrollable :title="$t('bookingTransport.edit')" tabindex="-1" >
     <template #modal-header>
        <div class="w-100">
            <h3>
          <p class="labelBold float-left">{{$t('bookingTransport.edit')}}</p>
          </h3>
        </div>
      </template>
            <b-container class="bv-example-row">
                <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
                            <b-col>  
                            <label class="labelBold">{{ $t("bookingTransport.Platform.name") }}</label>
                            <input type="text" v-model="EditAnden" />
                            </b-col>
                    </b-row>
            </b-container>

        
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>    
             <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditConfirm()"
          >
            Guardar
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeEdit()"
          >
            Cancelar
          </b-button>
          
        </div>
      </template>
        </b-modal>
   
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/Booking.js";
import store from '@/vuex/store';
const api = new API_SERVICE();


import S3_Handler from "@/lib/api/s3_handler";
const s3 = new S3_Handler();

export default {

components: {
    store
  },

data() {
    return {

        Anden:"",
        EditAnden:"",
        filePlatform:null,
        filelocation:null,
        error:null,
        file:false,
        fileOk:false,

        nuevo:false,
        selected:"",
        id:"",
        
        car_plate:"",
        status:"",
        controlNumber:"",
          columns: [
          "id",
          "name",
          "action",],
        tableData: [
    {
        "id": 12168,
        "name": "Capu"
     
    },
    {
        "id": 11963,
        "name": "Las Animas"

    },
    {
        "id": 11352,
        "name": "Loreto"

    }
]
    };
  },

computed:{

       routesTable: function() {
      return this.$refs.routesTable;

    },
      appLang: function () 
      { 
       return this.$store.getters["settings/currentLang"];
        },

      options(){
      return[
      {id:"choose",name: this.$t('mobilityOnDemand.choose')} ,
      {id:true,name: this.$t("mobilityOnDemand.driversMobility.active")} ,
      {id:false,name: this.$t("mobilityOnDemand.driversMobility.inactive")},
      {id:null,name: this.$t("mobilityOnDemand.driversMobility.noDriver")}
        ]},


     table_columns: function() {
      return [
            "id",
            "platform_name",
            "schedule",
            "actions"
      ];
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(
            `bookingTransport.Platform.tablePlatform.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(column => column !== "actions");
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          resizableColumns: false,
          perPageValues: [25, 50, 100],
          perPage: 25,
           columnsClasses: {
            actions: "actions-column",
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("bookingTransport.Platform.tablePlatform.headings.column_toggler"),
            limit: this.$t("bookingTransport.Platform.tablePlatform.headings.limit")
        
          },

          requestAdapter: function(data) {
            const queries = {};
            queries.catalogType = "platforms"
            queries.pagination= {all:false,
                                 limit:data.limit,
                                 page:data.page
                                 };
            queries.filters = data.query;
            return queries;
          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            try {

              const resp = await api.getLists(data);
              this.$store.commit("global/SET_LOADING", false);
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                 msg: `${error}`,
                 show: true,
                 type: "error"
               });
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data: response.data,
              count: response.total
            };
          }
        }
      };
    },

    table_headingsCarga: function () {
      if (this.columns) {
        const headings = {};
        this.columns.forEach((column) => {
          headings[column] = this.$t(`bookingTransport.Platform.tablePlatform.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filtersCarga: function () {
      return this.columns.filter((column) => column !== "action");
    },
 table_optionsCarga: function () {
      return {
        columns: this.columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headingsCarga,
          filterable: this.table_filtersCarga,
          sortable: [],
          resizableColumns: false,// columnas fijas
          perPage: 25,
          perPageValues: [25, 50, 100],
          columnsClasses: {
            select: "select-column",
            id: "id-column",
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler"),
            limit: this.$t("users.search.table.limit")
          },
        },
      };
    }
},

methods: {
    updateTable: function() {
         this.routesTable.refresh();
       },

  Upload: async function(){
   await this.uploadFile();
  },

    uploadFile: async function() {
      try {

        if(this.filelocation){
        this.$store.commit("global/SET_LOADING", true); 
      
        //  console.log(fileResp);
        //  console.log(Bucket);
        //  console.log(Key);
        //  this.alert.status = 'loading';

         var json = {upload_type: "platforms",
                     url: this.filelocation}
         
        const resp = await api.uploadFile(json);

        console.log(resp);

        if(resp.message == "Datos insertados correctamente."){
        this.filelocation = null;
        this.filePlatform = null;
        this.file = false;
        this.fileOk = false;
        document.getElementById("file-2").value = "";
        document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");

        this.$store.commit("global/SET_ALERT", {
                 msg: this.$t("bookingTransport.success"),
                 show: true,
                 type: "success"
               });
        }
        else{
                 console.log(resp);
                 this.$store.commit("global/SET_ALERT", {
                 msg: resp,
                 show: true,
                 type: "error"
               });


        }
        this.updateTable();
        this.$store.commit("global/SET_LOADING", false); 
        }
        // else
        // {
        //         this.$store.commit("global/SET_ALERT", {
        //          msg: this.$t("bookingTransport.noFile"),
        //          show: true,
        //          type: "error"
        //        });
        // }
        // await api.uploadUsers(Bucket, Key, userType);
        // this.backendError = '';
        // this.alert.status = 'success';
        // this.loadingFile = false;
        // this.file = null;
        // this.fileUrl = null;
        // this.$v.$reset();
        // this.$emit('updateTable');
      } catch (error) {

         this.$store.commit("global/SET_LOADING", false); 
         console.log(error);

         this.$store.commit("global/SET_ALERT", {
                  msg: error,
                  show: true,
                  type: "error"
                });
        if(error.response.data.hasOwnProperty('err')){
         
          console.log(error);
          // this.backendError = error.response.data.err.replace(': ', ':<br>').replace(/required.,/g, 'required.<br>');
          this.backendError = error.response.data.err.replace('.', ' ').replace(/required.,/g, 'required.</br>').replace("\n", "<br/>");
          this.$refs['my-info'].show();
          
        }
        this.alert.status = 'error';
        this.loadingFile = false;
        throw error;
      }
    },


         Modify: function(name){
            this.EditAnden = name;
            this.$refs['my-edit'].show();
      
    },


       loadCSV: async function(e){ 

        try{

        this.$store.commit("global/SET_LOADING", true); 

        this.filePlatform = e.target.files[0]; 
        document.getElementById('filecsv').textContent = e.target.files[0].name;
        const timestamp = Date.now();
        let Type = "Platform";
        const file = `Booking/${Type}/${timestamp}_${Type}.csv`;
        const fileResp = await s3.uploadFile(file, this.filePlatform);
        const {Location} = fileResp;
        this.filelocation = Location;
        this.file = true;

         var json = {upload_type: "platforms",
                     url: Location}

        const resp = await api.validate(json)

        this.$store.commit("global/SET_LOADING", false); 
         
         if(resp.message == "Datos fueron validados correctamente."){

              this.fileOk = true;
              this.$store.commit("global/SET_ALERT", {
                 msg: this.$t("bookingTransport.Routes.ready"),
                 show: true,
                 type: "success"
               });

         }
         else{
          this.$refs['my-error'].show();
          const backendError = resp.errors.toString().replace(/,/g, '\n');
          // var backendError1 = backendError.toString().replace(/,/g, '\n');
          // alert(backendError.toString());
          //const backendError = error.response.data.err.replace('.', ' ').replace(/required.,/g, 'required.</br>').replace("\n", "<br/>");
          //this.error = resp.errors;
          // this.error = backendError.toString();
          this.error = backendError;
         }
        }
        catch(error)
        {
            console.log(error);
            this.$store.commit("global/SET_LOADING", false); 
            this.$store.commit("global/SET_ALERT", {
                 msg: error.response.data.message,
                 show: true,
                 type: "error"
               });
        }
       },

        showInf: function(){
          this.$refs['my-info'].show();
        },

    removeFile: function () {

      try{  
        this.filelocation = null;
        this.filePlatform = null;
        this.file = false;
        this.fileOk = false;
        document.getElementById("file-2").value = "";
        document.getElementById('filecsv').textContent = this.$t("bookingTransport.selectFile");

        this.$store.commit("global/SET_ALERT", {
                 msg: this.$t("bookingTransport.delete"),
                 show: true,
                 type: "error"
               });
        }
        catch(error){

            this.$store.commit("global/SET_LOADING", false); 
            this.$store.commit("global/SET_ALERT", {
                 msg: error.response.data.message,
                 show: true,
                 type: "error"
               });

        }
    },
      showModal() {
      this.$refs['my-modal'].show();
      },
      closeEdit(){
          this.$refs['my-edit'].hide();
      },
      EditConfirm(){
                this.$store.commit("global/SET_ALERT", {
                  msg: "Guardado Correctamente",
                  show: true,
                  type: "success"
                });
          this.$refs['my-edit'].hide();
      },
      DowloadLayout(){

        try{
                let anchor = document.createElement("a");
                anchor.href = "https://817467424320-amap-dbs-qa-app-files.s3.ca-central-1.amazonaws.com/Booking/Routes/Rutas_Layout.csv";
                anchor.target = "_blank";
                anchor.click();

                  this.$refs['my-info'].hide();
                  this.$store.commit("global/SET_ALERT", {
                  msg: this.$t("bookingTransport.dowloaded"),
                  show: true,
                  type: "success"});

                }
                catch(error){
                  this.$store.commit("global/SET_ALERT", {
                  msg: error,
                  show: true,
                  type: "error"
                });
        }
    }    
}


};
</script>

<style lang="scss" scoped>
#Stops {
  background-color: $white;
  padding: 2rem 4rem;
}

.btn-confirm {
  margin-left: 1rem;
  padding:1rem 1rem;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
}
.container-input {
    text-align: center;
    background: #fff; //#b6b0b0;
    border-top: 0px solid #fff; //#000000;
    padding: 0px 0;
    border-radius: 6px;
    width: 90%;
    height: 90%;
    margin: 0 auto;
    margin-bottom: 1em;
}

.inputfile {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
   
}

.inputfile + label {
    max-width: 100%;
    font-size: 1.35rem;
    font-weight: 200;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    padding: 0.625rem 1.25rem;
}

.inputfile + label i {
    width: 1em;
    height: 1em;
    vertical-align: middle;
    fill: currentColor;
    margin-top: -0.25em;
    margin-right: 0.45em;
}

.iborrainputfile {
  font-size:14px; 
}

.inputfile-2 + label {
    color: #fff;
    background-color: #000000;
}

.inputfile-2:focus + label,
.inputfile-2.has-focus + label,
.inputfile-2 + label:hover {
    background-color: #ffffff;
    color: #000000;
    border: 1px solid #000000;
}

</style>

